import { render, staticRenderFns } from "./Lantern.vue?vue&type=template&id=d4252e6a&"
import script from "./Lantern.vue?vue&type=script&lang=js&"
export * from "./Lantern.vue?vue&type=script&lang=js&"
import style0 from "./Lantern.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports